import React from 'react';

const VehiclePathDisplay = ({ path, locations, duration, className }) => {
  if (!path || path.length < 2) {
    return null;
  }

  // Format path into a simple arrow-separated list
  const formatPathSequence = (path, locations) => {
    if (!path || !Array.isArray(path) || path.length === 0) {
      return "No path data";
    }
    
    return path.map(point => {
      // Handle different point formats
      const pointId = typeof point === 'string' 
        ? point 
        : (point.id || point);
      
      // Get location name or use ID if not found
      const loc = locations.find(l => l.id === pointId);
      return loc ? (loc.name || pointId) : pointId;
    }).join(" → ");
  };

  // Use orange color for custom path, blue for auto path
  const headerColor = className === 'custom' ? '#FF5722' : '#4285F4';

  return (
    <div className="vehicle-paths-container">
      <div className="vehicle-path-card">
        <div className="vehicle-path-header" style={{background: headerColor}}>
          <span className="vehicle-number">Route 1</span>
          <span className="path-duration-value">
            {duration > 0 ? `${duration.toFixed(1)} hours` : '0.0 hours'}
          </span>
        </div>
        <div className="vehicle-path-sequence">
          {formatPathSequence(path, locations)}
        </div>
      </div>
    </div>
  );
};

export default VehiclePathDisplay; 